<ng-container *ngIf="viewModel$ | async as viewModel">
  <section *ngIf="viewModel.visible && viewModel.shipmentDates.length" class="auto-ship-shipment-dates"
    aria-labelledby="auto-ship-shipment-dates-heading">
    <h2 id="auto-ship-shipment-dates-heading" class="auto-ship-shipment-dates__heading">
      {{ 'autoShip.shipmentDates.title' | cxTranslate: { count: viewModel.shipmentDates.length } }}
    </h2>

    <ul class="auto-ship-shipment-dates__list">
      <li
        *ngFor="let shipmentDate of (expanded ? viewModel.shipmentDates : (viewModel.shipmentDates | slice: 0 : initialVisibleDates)); trackBy: trackByShipmentDate">
        {{ shipmentDate | date: 'MMM d, y': 'UTC' }}
      </li>
    </ul>

    <button *ngIf="viewModel.shipmentDates.length > initialVisibleDates" type="button"
      class="auto-ship-shipment-dates__toggle" [attr.aria-expanded]="expanded" (click)="toggleDates()">
      {{ (expanded ? 'autoShip.shipmentDates.showLess' : 'autoShip.shipmentDates.viewAll')
      | cxTranslate: { count: viewModel.shipmentDates.length } }}
    </button>
  </section>
</ng-container>